import AOS from 'aos';

'use strict';
const aos = {
	init: function() {
		let timeout = 0;

		if (aos.isCookieSet('googtrans')) {
			timeout = 1500;
		}

		setTimeout(() => {
			AOS.init({
				once: true,
				offset: 0,
				duration: 600,
				disable: function() {
					const maxWidth = 1200;
					return window.innerWidth < maxWidth;
				}
			});
		}, timeout);
	},

	isCookieSet: function(cookieName) {
		// Split cookie string and get all individual name=value pairs in an array
		const cookieArr = document.cookie.split(';');

		// Loop through the array elements
		for (let i = 0; i < cookieArr.length; i++) {
			const cookiePair = cookieArr[i].split('=');

			// Remove whitespace from the cookie name
			const name = cookiePair[0].trim();

			// If the found cookie matches the specified name, return true
			if (name === cookieName) {
				return true;
			}
		}

		// If the cookie is not found, return false
		return false;
	},
};

export default aos;
